import Link from 'next/link';
import React from "react";
// import "./style.scss";

function Education(props) {
	const continuing_education_data = props?.continuingEducationsData.length ? props?.continuingEducationsData[0] : null;
	let education_data = continuing_education_data?.section_ed.map((innerItem) => (
		<Link href={innerItem?.link} as={innerItem?.link}>
			<div className="edu-list" id="earn-a-certificate">
				{/*<span className="inner-img"><img src={`${process.env.IMAGES_BASE_URL}/static-content/earn-certificate.png.webp`} alt="earn-certificate" width="70"/></span>*/}
				<span className="inner-img"><img src={`${process.env.CMS_API_ORIGIN}${innerItem?.image?.url??''}`} alt="earn-certificate" width="70"/></span>
				<div>
					<h2>{innerItem?.heading??''}</h2>
					<p>{innerItem?.description??''}</p>
				</div>
				<div>
					<a className="more-info"></a>
				</div>
			</div>
		</Link>
	))
	return (
		<>
			<div className="education-page">
				<div className="container container-sm">
					{/*<h1 className="text-center headingF headingF-sm">Continuing Education</h1>*/}
					<h1 className="text-center headingF headingF-sm">{continuing_education_data?.page_title??''}</h1>
					{education_data??''}
					{/*<Link href="/certificates" as="/certificates">*/}
					{/*<div className="edu-list" id="earn-a-certificate">*/}
					{/*	<span className="inner-img"><img src={`${process.env.IMAGES_BASE_URL}/static-content/earn-certificate.png.webp`} alt="earn-certificate" width="70"/></span>*/}
					{/*	<div>*/}
					{/*		<h2>Earn a Certificate</h2>*/}
					{/*		<p>Valuable as a form of Professional Development (PD), Continuing Education, or as a way to explore our courses before officially beginning your Master's Degree studies.</p>*/}
					{/*	</div>*/}
					{/*	<div>*/}
					{/*		<a className="more-info"></a>*/}
					{/*	</div>*/}
					{/*	</div>*/}
					{/*</Link>*/}
					{/*<Link href="/courses" as="/courses">*/}
					{/*	<div className="edu-list" id="course-description">*/}
					{/*		<span className="inner-img"><img src={`${process.env.IMAGES_BASE_URL}/static-content/course-description.png.webp`} alt="course-description" width="100" /></span>*/}
					{/*		<div>*/}
					{/*			<h2>Course Descriptions</h2>*/}
					{/*			<p>See a breakdown of available courses and their descriptions.</p>*/}
					{/*		</div>*/}
					{/*		<div>*/}
					{/*			<a className="more-info"></a>*/}
					{/*		</div>*/}
					{/*	</div>*/}
					{/*</Link>*/}
					{/*<Link href="/library" as="/library">*/}
					{/*	<div className="edu-list" id="bayan-online">*/}
					{/*		<span className="inner-img"><img src={`${process.env.IMAGES_BASE_URL}/static-content/bayan-onine.png.webp`} alt="bayan-onine" width="100" /></span>*/}
					{/*		<div>*/}
					{/*			<h2>Self-Paced Courses</h2>*/}
					{/*			<p>Unlimited access to courses in Islamic Studies, Chaplaincy, & more at your fingertips for $10/month</p>*/}
					{/*		</div>*/}
					{/*		<div>*/}
					{/*			<a className="more-info"></a>*/}
					{/*		</div>*/}
					{/*	</div>*/}
					{/*</Link>*/}
					{/*<Link href="/arabic" as="/arabic" >*/}
					{/*	<div className="edu-list" id="arabic-online">*/}
					{/*		<span className="inner-img"><img src={`${process.env.IMAGES_BASE_URL}/static-content/intensive-arabic-online.png.webp`} alt="intensive-arabic-online" width="100" /></span>*/}
					{/*		<div>*/}
					{/*			<h2>Learn Intensive Arabic Online</h2>*/}
					{/*			<p>Taking Arabic through continuing education is a great way for members of the general public to study the language in an academic manner. It is also beneficial for high school, undergraduate and graduate students who wish to improve their Arabic language fluency. Enrolling in this way means that no academic credit is granted and no transcript is provided for completed courses.</p>*/}
					{/*		</div>*/}
					{/*		<div>*/}
					{/*			<a className="more-info"></a>*/}
					{/*		</div> */}
					{/*	</div>*/}
					{/*</Link>*/}
				</div>
				
			</div>
		</>
	);
}

export default Education;
